<nav>
  <div class="nav-wrapper">
    <a class="brand-logo" type="button" routerLink="">
      <img src="./assets/logos/logo.svg" alt="Nutrientes Criativos">
    </a>

    <a href="#" data-target="mobile-demo" class="sidenav-trigger"><i class="material-icons">menu</i></a>

    <ul class="right hide-on-med-and-down">
      <li class="dashboard-navbar-item">
        <a class="dashboard-navbar-item--link" (click)="logout()">
          <i class="material-icons">input</i>
          Sair
        </a>
      </li>
    </ul>
  </div>
</nav>

<ul class="sidenav sidenav-items" id="mobile-demo">
  <li><a routerLink="/painel-pessoa-juridica">Resíduos</a></li>
  <li><a routerLink="/solicitantes-residuos">Solicitantes</a></li>
  <li><a routerLink="/cadastro-residuos">Cadastrar resíduos</a></li>

  <a class="btn btn-secondary waves-effect waves-light darken-3 text-white sidenav-logout" (click)="logout()">Sair</a>
</ul>

<div class="container-fluid">
  <div class="row">
    <div class="dashboard-sidebar col-md-2 hide-on-med-and-down">
      <ul class="dashboard-sidebar-items">
        <a class="dashboard-sidebar-item--link" routerLink="/painel-pessoa-juridica">
          <li class="col dashboard-sidebar-item dashboard-sidebar-item--link">
            <i class="material-icons dashboard-sidebar-item--link-icon">home</i>
            Resíduos
        </li>
        </a>
        <a class="dashboard-sidebar-item--link" routerLink="/solicitantes-residuos">
        <li class="col dashboard-sidebar-item dashboard-sidebar-item--link">
            <i class="material-icons dashboard-sidebar-item--link-icon">group</i>
            Solicitantes
          </li>
        </a>
        <a class="dashboard-sidebar-item--link" routerLink="/cadastro-residuos">
          <li class="col dashboard-sidebar-item dashboard-sidebar-item--link active">
            <i class="material-icons dashboard-sidebar-item--link-icon">add</i>
            Cadastrar resíduos
          </li>
        </a>
      </ul>
    </div>
    <main class="dashboard-content col-md-10 pt-3 px-4">
      <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pb-2 mb-3 border-bottom">
        <h1 class="h2">Cadastrar resíduos</h1>
      </div>
      <form class="add-residues-container-card--form" #addResidueForm="ngForm" (ngSubmit)="onSubmit()">
        <div class="add-residues-container-card--form-input">
          <label for="residueName">Nome do resíduo</label>
          <input type="text" residueName id="residueName" name="residueName" [(ngModel)]=" addResiduesForm.name"
            #residueName="ngModel" class="form-control" placeholder="Digite o nome do resíduo">
        </div>

        <div class="add-residues-container-card--form-input">
          <label for="residueDescription">Descrição do resíduo</label>
          <input type="text" residueDescription id="residueDescription" [(ngModel)]="addResiduesForm.description"
            #residueDescription="ngModel" class="form-control" placeholder="Digite a descrição do resíduo">
        </div>

        <div class="add-residues-container-card--form-input-group">
          <div class="add-residues-container-card--form-input">
            <div class="checkboxesLabel"><label>Setores do resíduo</label></div>

            <label>
              <input value="Retalhos de Tecidos Sintéticos" class="filled-in" type="checkbox" id="sectorCheckbox1"
                (change)="addSector($event)" />
              <span>Retalhos de Tecidos Sintéticos</span>
            </label>

            <label>
              <input value="Retalhos de Tecidos Planos" class="filled-in" type="checkbox" id="sectorCheckbox2"
                (change)="addSector($event)" />
              <span>Retalhos de Tecidos Planos</span>
            </label>


            <label>
              <input value="Retalhos de Tecidos de Malha" class="filled-in" type="checkbox" id="sectorCheckbox3"
                (change)="addSector($event)" />
              <span>Retalhos de Tecidos de Malha</span>
            </label>


            <label>
              <input value="Fibras Têxteis" class="filled-in" type="checkbox" id="sectorCheckbox4"
                (change)="addSector($event)" />
              <span>Fibras Têxteis</span>
            </label>

            <label>
              <input value=" Plástico: botões,manequins,tubo de linhas e cabides" class="filled-in" type="checkbox"
                id="sectorCheckbox5" (change)="addSector($event)" />
              <span> Plástico: botões,manequins,tubo de linhas e cabides</span>
            </label>

            <label>
              <input value="Plástico: embalagens de produtos" class="filled-in" type="checkbox" id="sectorCheckbox6"
                (change)="addSector($event)" />
              <span>Plástico: embalagens de produtos</span>
            </label>

            <label>
              <input value="Plástico: sacolas" class="filled-in" type="checkbox" id="sectorCheckbox7"
                (change)="addSector($event)" />
              <span>Plástico: sacolas</span>
            </label>

            <label>
              <input value="Plástico: tampas" class="filled-in" type="checkbox" id="sectorCheckbox8"
                (change)="addSector($event)" />
              <span>Plástico: tampas</span>
            </label>

            <label>
              <input value="Plástico: garrafa pet" class="filled-in" type="checkbox" id="sectorCheckbox9"
                (change)="addSector($event)" />
              <span>Plástico: garrafa pet</span>
            </label>

            <label>
              <input value="Papel e Papelão" class="filled-in" type="checkbox" id="sectorCheckbox10"
                (change)="addSector($event)" />
              <span>Papel e Papelão</span>
            </label>

            <label>
              <input value="Outros" class="filled-in" type="checkbox" id="sectorCheckbox11"
                (change)="addSector($event)" />
              <span>Outros</span>
            </label>
          </div>
          <div class="add-residues-container-card--form-input">
            <div class="checkboxesLabel"><label>Tipos do resíduo</label></div>
            <label>
              <input value="Confecção Moda Praia" type="checkbox" class="filled-in" id="typeCheckbox1"
                (click)="addType($event)">
              <span>Confecção Moda Praia</span>
            </label>
            <label>
              <input value="Confecção Moda Fitness" type="checkbox" class="filled-in" id="typeCheckbox2"
                (click)="addType($event)">
              <span>Confecção Moda Fitness</span>
            </label>
            <label>
              <input value="Confecção Surfwear" type="checkbox" class="filled-in" id="typeCheckbox3"
                (click)="addType($event)">
              <span>Confecção Surfwear</span>
            </label>
            <label>
              <input value="Confecção Tecido Plano e Malha" type="checkbox" class="filled-in" id="typeCheckbox4"
                (click)="addType($event)">
              <span>Confecção Tecido Plano e Malha</span>
            </label>
            <label>
              <input value="Lavanderia de Beneficiamento" type="checkbox" class="filled-in" id="typeCheckbox5"
                (click)="addType($event)">
              <span>Lavanderia de Beneficiamento</span>
            </label>
            <label>
              <input value="Aviamento" type="checkbox" class="filled-in" id="typeCheckbox6" (click)="addType($event)">
              <span>Aviamento</span>
            </label>
            <label>
              <input value="Embalagem" type="checkbox" class="filled-in" id="typeCheckbox7" (click)="addType($event)">
              <span>Embalagem</span>
            </label>
            <label>
              <input value="Acessórios" type="checkbox" class="filled-in" id="typeCheckbox8" (click)="addType($event)">
              <span>Acessórios</span>
            </label>
            <label>
              <input value="Outros" type="checkbox" class="filled-in" id="typeCheckbox9" (click)="addType($event)">
              <span>Outros</span>
            </label>
          </div>
        </div>

        <div class="add-residues-container-card--form-image-upload">
          <label for="foto">Selecione a foto do resíduo</label>
          <input type="file" class="upload-photo" (change)="upload($event)">
          <mat-progress-bar *ngIf="isUploading" mode="indeterminate"></mat-progress-bar>
        </div>
        

        <button class="btn btn-primary add-residues-container-card--form-submit" type="submit"
          [disabled]="addResidueForm.invalid">Cadastrar resíduo
        </button>
      </form>
    </main>
  </div>
</div>